import {Component, Input} from '@angular/core';
import {IonSlides} from '@ionic/angular';
import {File} from 'app/entities/file.entity';
import {AppService} from 'app/services/app.service';

@Component({
  selector: 'app-file-slider',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class FileSliderComponent {
  appService: AppService;
  ionSlides: IonSlides;

  // @todo SAKURA-113 active index not found on console https://c2n.me/4hFhCf9.png
  activeIndex = 0;
  filesReady = false;
  loaded = false;
  slidesOptions: any = {
    slidesPerView: 1,
    loop: false,
    pagination: false,
  };
  dynamicPaginationThreshold = 15;

  _files: File[] = [];

  @Input() name = '';
  // @TODO fix tslint for constructor ordering
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @Input() title: string = null;

  // @Input() files: File[] = [];

  get files(): File[] {
    return this._files;
  }

  @Input() set files(files: File[]) {
    this._files = files;

    this.prepareSwiper();
    // console.log('files', files);
    //
    // setTimeout(() => {
    //   console.log('set files');
    //   this.ionSlides?.update();
    // }, 100);

  };

  // @TODO fix tslint for constructor ordering
  // eslint-disable-next-line @typescript-eslint/member-ordering
  constructor(
    appService: AppService
  ) {
    this.appService = appService;
    this.filesReady = false;
  }

  prepareSwiper() {
    this.filesReady = false;
    this.loaded = false;

    if (this.files.length >= 2) {
      this.slidesOptions.pagination = {
        el: '.swiper-pagination',
        clickable: false,
        dynamicBullets: this.files.length > this.dynamicPaginationThreshold,
        dynamicMainBullets: 1
      };
      this.slidesOptions.loop = true;
    } else {
      this.slidesOptions = {
        slidesPerView: 1,
        loop: false,
        pagination: false,
      };

    }

    // console.log('slidesOptions', this.slidesOptions);
    setTimeout(() => {
      this.filesReady = true;
    }, 100);
  }

  swiperReady(ionSlides: IonSlides) {
    this.ionSlides = ionSlides;

    setTimeout(async () => {
      await this.ionSlides.update();
      await this.ionSlides.updateAutoHeight(0);
      this.loaded = true;
    }, 500);
  }

  openFileModal() {
    this.ionSlides?.getActiveIndex().then((index) => {

      if (this.files.length === 1) {
        index = 1;
      }

      this.appService.appModalService.openGalleryModal(this.files, (index - 1));
    });
  }

  slideChanged(event: any) {
    this.ionSlides?.getActiveIndex().then((index) => {
      this.activeIndex = index;
    });
  }
}
